module.exports = __webpack_public_path__ + "static/media/controller.8fb1fa3b.png";